import { IsoCardModel, IsoCardModelProps as IsoCardModelProps } from '@/src/components/cards/banner-images/iso';
import { CertificateCardsCaraousl } from './card-carousel';
import { CertificateCardModelProps } from '@/src/components/cards/banner-images/certificate';

export interface CertificateModelSectionProps {
   cards: CertificateCardModelProps[];
}

export function CertificateModelSection({ cards }: CertificateModelSectionProps) {
   return (
      <section className="overflow-hidden">
         <CertificateCardsCaraousl cards={cards} />
      </section>
   );
}